<!--
  ~ Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->

<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content id="popup-container">
  <span>{{info}}</span>
</div>
<div mat-dialog-actions id="actions-container">
  <button mat-stroked-button mat-dialog-close id="cancel-button">Close</button>
</div>
